/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { BenutzerVomDienstBefreienRequest } from '../model/benutzerVomDienstBefreienRequest';
// @ts-ignore
import { BenutzerZumDienstEinteilenMultiRequest } from '../model/benutzerZumDienstEinteilenMultiRequest';
// @ts-ignore
import { BenutzerZumDienstEinteilenRequest } from '../model/benutzerZumDienstEinteilenRequest';
// @ts-ignore
import { VeranstaltungRolleIdentifier } from '../model/veranstaltungRolleIdentifier';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class RollenCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostBenutzerVomDienstBefreien
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerRolleNichtGefunden: (VeranstaltungRolleNichtGefunden) * VerRolleEntfernt: (VeranstaltungRolleEntfernt) 
     * @endpoint post /api/ver/command/rollen/v1/dienst/befreien
     * @param benutzerVomDienstBefreienRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerVomDienstBefreien(benutzerVomDienstBefreienRequest: BenutzerVomDienstBefreienRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungRolleIdentifier>;
    public postBenutzerVomDienstBefreien(benutzerVomDienstBefreienRequest: BenutzerVomDienstBefreienRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungRolleIdentifier>>;
    public postBenutzerVomDienstBefreien(benutzerVomDienstBefreienRequest: BenutzerVomDienstBefreienRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungRolleIdentifier>>;
    public postBenutzerVomDienstBefreien(benutzerVomDienstBefreienRequest: BenutzerVomDienstBefreienRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerVomDienstBefreienRequest === null || benutzerVomDienstBefreienRequest === undefined) {
            throw new Error('Required parameter benutzerVomDienstBefreienRequest was null or undefined when calling postBenutzerVomDienstBefreien.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/rollen/v1/dienst/befreien`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungRolleIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerVomDienstBefreienRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerZumDienstEinteilen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerRolleNichtGefunden: (VeranstaltungRolleNichtGefunden) * VerRolleEntfernt: (VeranstaltungRolleEntfernt) 
     * @endpoint post /api/ver/command/rollen/v1/dienst/einteilen
     * @param benutzerZumDienstEinteilenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerZumDienstEinteilen(benutzerZumDienstEinteilenRequest: BenutzerZumDienstEinteilenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungRolleIdentifier>;
    public postBenutzerZumDienstEinteilen(benutzerZumDienstEinteilenRequest: BenutzerZumDienstEinteilenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungRolleIdentifier>>;
    public postBenutzerZumDienstEinteilen(benutzerZumDienstEinteilenRequest: BenutzerZumDienstEinteilenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungRolleIdentifier>>;
    public postBenutzerZumDienstEinteilen(benutzerZumDienstEinteilenRequest: BenutzerZumDienstEinteilenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerZumDienstEinteilenRequest === null || benutzerZumDienstEinteilenRequest === undefined) {
            throw new Error('Required parameter benutzerZumDienstEinteilenRequest was null or undefined when calling postBenutzerZumDienstEinteilen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/rollen/v1/dienst/einteilen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungRolleIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerZumDienstEinteilenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerZumDienstEinteilenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerRolleNichtGefunden: (VeranstaltungRolleNichtGefunden) * VerRolleEntfernt: (VeranstaltungRolleEntfernt) 
     * @endpoint post /api/ver/command/rollen/v1/dienst/einteilen/multi
     * @param benutzerZumDienstEinteilenMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerZumDienstEinteilenMulti(benutzerZumDienstEinteilenMultiRequest: BenutzerZumDienstEinteilenMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungRolleIdentifier>;
    public postBenutzerZumDienstEinteilenMulti(benutzerZumDienstEinteilenMultiRequest: BenutzerZumDienstEinteilenMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungRolleIdentifier>>;
    public postBenutzerZumDienstEinteilenMulti(benutzerZumDienstEinteilenMultiRequest: BenutzerZumDienstEinteilenMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungRolleIdentifier>>;
    public postBenutzerZumDienstEinteilenMulti(benutzerZumDienstEinteilenMultiRequest: BenutzerZumDienstEinteilenMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerZumDienstEinteilenMultiRequest === null || benutzerZumDienstEinteilenMultiRequest === undefined) {
            throw new Error('Required parameter benutzerZumDienstEinteilenMultiRequest was null or undefined when calling postBenutzerZumDienstEinteilenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/rollen/v1/dienst/einteilen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungRolleIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerZumDienstEinteilenMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
